import type {
  SidebarLink,
  SidebarLinksGroup,
} from './types';

export const constructLinksPath = (
  linksGroups: (SidebarLink | SidebarLinksGroup)[],
  currentUrl: string | null,
): number[] | null => {
  if (typeof currentUrl !== 'string') {
    return null;
  }

  for (let i = 0, l = linksGroups.length; i < l; ++i) {
    const linksGroup = linksGroups[i];

    const {
      type,
    } = linksGroup;

    switch (linksGroup.type) {
      case 'link':
        if (currentUrl.startsWith(linksGroup.payload.url)) {
          return [i];
        }
        break;

      case 'group':
      {
        const subgroupRes = constructLinksPath(
          linksGroup.payload.links,
          currentUrl,
        );

        if (subgroupRes) {
          return [i].concat(subgroupRes);
        }

        break;
      }

      default:
        throw new Error(`Unknown links group type: "${type}"`);
    }
  }

  return null;
};
